import { useReduxState } from 'hooks';
import { getCourseLanguageVersionOptions } from 'lib/courses';
import { Filters, FiltersActive } from 'components/common/filter';
import { FollowUsersSearch, FollowUsersViewSelector } from '.';

const FollowUsersListFilters = () => {
  const {
    messages,
    pageState: { course },
    theme
  } = useReduxState();

  return (
    <div className="subheader">
      <div className="filters">
        <div className="dropdown">
          <FollowUsersSearch />

          <Filters
            allowMultiple={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              userAttributes: true
            }}
            customFilters={[
              {
                allowMultiple: true,
                field: 'completionStatus',
                icon: 'certificate' as const,
                items: [
                  { label: messages.commonCompleted, value: 'yes' },
                  { label: messages.completionsValid, value: 'valid' },
                  { label: messages.completionsExpired, value: 'expired' },
                  { label: messages.completionsExpiring, value: 'expiring' },
                  { label: messages.readerCompletionFailed, value: 'failed' },
                  {
                    label: messages.completionsWaitingForReviews,
                    value: 'waitingForReviews'
                  },
                  { label: messages.commonInProgress, value: 'inProgress' },
                  {
                    label: messages.commonNotStarted,
                    value: 'notStarted'
                  },
                  {
                    label: messages.tasksUsersNotCompletedSingular,
                    value: 'no'
                  }
                ],
                position: 4,
                selectAllOnClick: true,
                title: messages.commonCompletion
              },
              {
                allowMultiple: false,
                field: 'courseAccess',
                icon: 'door-open' as const,
                items: [
                  {
                    label: messages.commonAccessCurrentParticipants,
                    value: 'withAccess'
                  },
                  {
                    label: messages.commonAccessFormerParticipants,
                    value: 'withoutAccess'
                  }
                ],
                position: 3,
                title: messages.commonAccess
              },
              ...(Object.keys(course.languageVersions)?.length > 0
                ? [
                    {
                      allowMultiple: true,
                      field: 'languageVersion',
                      icon: 'language' as const,
                      items: Object.entries(
                        getCourseLanguageVersionOptions({ course })
                      ).map(([langKey, langObj]) => ({
                        label: langObj.capitalizedName,
                        value: langKey
                      })),
                      position: 5,
                      selectAllOnClick: true,
                      title: messages.courseLanguageVersion
                    }
                  ]
                : [])
            ]}
            filterId="course-tasks-and-analytics"
            filters={{
              accountAccess: true,
              accountIdentifier: true,
              accountLogin: true,
              accountType: true,
              groups: true,
              userAttributes: true
            }}
          />
        </div>

        <FollowUsersViewSelector />
      </div>

      <FiltersActive filterId="course-tasks-and-analytics" />

      <style jsx>{`
        .subheader {
          display: flex;
          flex-direction: column;
          gap: 10px;
          width: 100%;
        }
        .filters {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: space-between;
          width: 100%;
        }
        .dropdown {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .dropdown-content {
          width: 300px;
        }
        .form-elements {
          display: flex;
          flex-direction: column;
          padding: 5px 15px;
        }
        .dropdown-actions {
          border-top: 1px solid ${theme.lightGreyDark};
          display: flex;
          gap: 5px;
          justify-content: flex-end;
          margin-top: 15px;
          padding: 10px 10px 0 0;
        }
      `}</style>
    </div>
  );
};

export default FollowUsersListFilters;
